import React from 'react'

import { Props } from './types'

import {
  HoursNotificationWrap,
  HoursNote,
} from './styles'

const HoursNotification: React.FC<Props> = ({ hours = '8:00am - 6:00pm PST' }): React.ReactElement => (
  <HoursNotificationWrap>
    <HoursNote>
      Due to COVID-19 our retail location hours may differ from those listed. Please contact us, Monday - Friday, {hours}, for quotes and service.
    </HoursNote>
  </HoursNotificationWrap>
)

export default HoursNotification
